document.addEventListener('click', function (e) {
  const closeBtn = e.target.closest('.menu-drawer-close-btn');
  if (!closeBtn) return;

  const drawer = document.querySelector('#Details-menu-drawer-container');
  const summary = drawer?.querySelector('summary');

  if (drawer) {
    drawer.removeAttribute('open');
    drawer.classList.remove('menu-opening');
  }

  if (summary) {
    summary.setAttribute('aria-expanded', 'false');
  }

  document.body.classList.remove('overflow-hidden-tablet');
  document.body.classList.remove('overflow-hidden-mobile');
});


function updateMobileFilterBadge() {
  const count = document.querySelectorAll('.active-facets-mobile .active-facets__button--light').length;
  const heading = document.querySelector('.mobile-facets__heading.medium-hide');
  if (!heading) return;

  let badge = heading.querySelector('.mobile-facets__count-badge');

  if (count > 0) {
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'mobile-facets__count-badge';
      heading.appendChild(badge);
    }
    badge.textContent = count;
  } else {
    if (badge) badge.remove();
  }
}

// On page load
updateMobileFilterBadge();

// Dawn re-renders active-facets via Ajax — observe it
const activeFacets = document.querySelector('.active-facets-mobile');
if (activeFacets) {
  new MutationObserver(updateMobileFilterBadge).observe(activeFacets, { childList: true, subtree: true });
}







// ------------------ Mobile Filter Drawer accordian start ------------------

document.addEventListener('click', function (e) {
  var summary = e.target.closest('details.mobile-facets__details.js-filter > .mobile-facets__summary');
  if (summary) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var details = summary.closest('details');
    if (details.hasAttribute('open')) {
      details.removeAttribute('open');
    } else {
      details.setAttribute('open', '');
    }
  }
}, true);

// Open all by default when drawer opens
document.addEventListener('click', function (e) {
  if (e.target.closest('.mobile-facets__open-wrapper, [data-breakpoint="mobile"]')) {
    setTimeout(function () {
      document.querySelectorAll('details.mobile-facets__details.js-filter').forEach(function (d) {
        d.setAttribute('open', '');
      });
    }, 100);
  }
});

// filter drawer accordian 
document.addEventListener('change', function () {
  setTimeout(() => {
    const wrapper = document.getElementById('ActiveFacetsWrapper');
    if (!wrapper) return;

    const tags = wrapper.querySelectorAll('.active-facets__button');
    const clearBtn = wrapper.querySelector('.active-facets__button-remove');
    const list = wrapper.querySelector('.active-facets__list');
    const title = wrapper.querySelector('.active-facets__title');

    const count = tags.length;

    // Update count
    if (title) {
      title.textContent = `Filtros (${count})`;
    }

    // Toggle visibility
    if (count === 0) {
      if (clearBtn) clearBtn.style.display = 'none';
      if (list) list.style.display = 'none';
    } else {
      if (clearBtn) clearBtn.style.display = 'flex';
      if (list) list.style.display = 'block';
    }

  }, 300);
});

console.log(document.querySelector('[id="estado-del-equipo"]'));
console.log(document.querySelector('[id="estado-del-equipo"] details'));
console.log(document.querySelector('[id="estado-del-equipo"] summary'));

// ------------------ Mobile Filter Drawer accordian end ------------------




document.addEventListener('DOMContentLoaded', () => {

  const sidebar = document.querySelector('[data-sidebar="size-chart"]');
  const overlay = document.querySelector('.sidebar-overlay');

  document.querySelectorAll('[data-sub="size-chart"]').forEach((button) => {
    button.addEventListener('click', () => {
      sidebar.classList.add('active');

      if (overlay) {
        overlay.classList.add('active');
      }

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    });
  });

  document.querySelectorAll('.sidebar-close').forEach((button) => {
    button.addEventListener('click', () => {
      sidebar.classList.remove('active');

      if (overlay) {
        overlay.classList.remove('active');
      }

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    });
  });

  if (overlay) {
    overlay.addEventListener('click', () => {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    });
  }

});



document.querySelectorAll('.model-measurement-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    const measurements = this.closest('.model-measurements');

    if (measurements) {
      measurements.classList.toggle('active');
    }
  });
});



(function() {

  function formatMoney(cents) {
    var amount = Math.round(cents) / 100;
    return '$' + amount.toLocaleString('es-MX', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function updateSavePrice(price, compareAt) {
    var el = document.querySelector('[data-save-price]');
    if (!el) return;
    if (compareAt && compareAt > price && (compareAt - price) > 15000) {
      el.textContent = 'Ahorra ' + formatMoney(compareAt - price);
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  }

  function readAndUpdate() {
    var scriptEl = document.querySelector('script[data-selected-variant]');
    if (!scriptEl || !scriptEl.textContent.trim()) return;
    try {
      var v = JSON.parse(scriptEl.textContent);
      updateSavePrice(v.price, v.compare_at_price);
    } catch(e) {}
  }

  // The only reliable hook — radio change on variant-selects
  // Dawn updates the JSON script tag synchronously before this fires
  // but section re-render happens async, so we try at 50ms and 300ms
  var variantSelects = document.querySelector('variant-selects');
  if (variantSelects) {
    variantSelects.addEventListener('change', function() {
      setTimeout(readAndUpdate, 50);
      setTimeout(readAndUpdate, 300);
    });
  }

  // Init on load
  readAndUpdate();

})();